<template>
    <b-card-text>
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent>
          <b-row>
            <b-col lg="4" md="6">
              <form-input
                label="اسم المنظمة قيد التأسيس"
                id="ngo-name"
                v-model="form.ngo_name"
                rules="required"
                @change="handleBlur('main', form.ngo_name)" 
              />
              
              <small class="text-danger" v-if="isTrueNgo_name">لا يمكن اختيار هذا الاسم لانه مستخدم </small>
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="الاسم البديل الأول"
                id="ngo-name"
                v-model="form.fst_alt_ngo_name"
                rules="required"
                @change="handleBlur('fst' , form.fst_alt_ngo_name)" 
              />
              <small class="text-danger" v-if="isTrueFst_alt_ngo_name"> لا يمكن اختيار هذا الاسم لانه مستخدم </small>
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="الاسم البديل الثاني"
                id="ngo-name"
                v-model="form.sec_alt_ngo_name"
                rules="required"
                @change="handleBlur('sec' , form.sec_alt_ngo_name)" 
              />
              <small class="text-danger" v-if='isTrueSec_alt_ngo_name'> لا يمكن استخدام هذا الاسم لانه مستخدم </small>
           </b-col>
            
            <b-col lg="4" md="6" v-if="!isCancel">
              <b-form-group
                v-slot="{ ariaDescribedby }"
                label="الشكل القانوني"
                label-for="legalForm"
              >
                <validation-provider
                  mode="passive"
                  #default="{ errors }"
                  name="الشكل القانوني"
                  rules="required"
                >
                  <b-form-radio-group
                    variant="success"
                    v-model="form.legal_form_type"
                    :options="legalFormOptions"
                    :aria-describedby="ariaDescribedby"
                    class="custom-control-success"
                    disabled-field="disabled"
                    id="legal-form-radio"
                    name="legal-form-radio"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col>
              <class-select
                :legalForm="form.legal_form_type"
                :isedit="isCancel"
                v-model="form.classification_ids"
                rules="required"
              />
            </b-col>
           
            <b-col lg="4" md="6">

              <form-select
                ep="v2/guest/selects/governorates"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                multiple
                :closeOnSelect="false"
                id="gov"
                v-model="form.governorate_ids"
                label="يتناول نشاطها المحافظات"
                rules="required"
              />
            </b-col>
            <b-col lg="12" md="6">

              <form-textarea v-model="form.objectives" rules="required" label="الأهداف">
              </form-textarea>
            </b-col>
            
            <b-col lg="12">
              <h3> معلومات المقر الرئيسي </h3>
              
              <hr />
            </b-col>
            <b-col lg="12">
              
            <b-col cols="12" class="mb-1 mt-1">
              <span class="text-muted">
                <feather-icon icon="InfoIcon" /> قم بالضغط على رمز الخريطة للبحث
                عن الموقع</span
              >
            </b-col>
            <b-col cols="12" class="d-flex align-items-center">
              <form-input
                readonly
                style="width: 45%"
                rules="required"
                label="خط الطول"
                v-model="form.longitude"
              />
              <form-input
                readonly
                class="mx-50"
                style="width: 45%"
                rules="required"
                label="خط العرض"
                v-model="form.latitude"
              />
              <b-button
                @click="mapModal = true;openMapModal(form) "
                class="btn btn-primary mt-50"
                variant="flat-primary"
              >
                <feather-icon icon="MapPinIcon" />
              </b-button>
            </b-col>
            </b-col>
            <b-col lg="12">
              <b-modal
                v-model="mapModal"
                centered
                size="lg"
                title="موقع معلومات المقر"
                footer-class="removed"
                class="edit-modal"
                id="branchModal"
              >
                <map-select
                  @closeModal="mapModal = false"
                  ref="mapModal"
                  @markerUpdated="onLocationSelect"
                  govsEndpoint="v2/guest/selects/governorates"
                  areasEndpoint="v2/establishment/map/governorate-areas/"
                />
              </b-modal>
              
              <b-row>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <h3> معلومات العقار </h3>
              <hr />
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="رقم العقار"
                id="ngo-name"
                v-model="form.number"
                rules="required|integer"
              />
            </b-col>
            <b-col lg="4" md="6">
              
              <form-select
                ep="v2/establishment/selects/estate-types"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                id="types"
                label="نوع العقار"
                rules="required"
                v-model="form.estate_type_id"
              />
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="المنطقة الإدارية"
                id="address"
                v-model="form.region"
                rules="required"
              />
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="الحصة السهمية"
                id="address"
                v-model="form.equity_share"
                rules="required|integer"
              />
            </b-col>
           
           <b-col lg="4" md="6">

             <form-select
               ep="v2/establishment/selects/possessive-forms"
               :reduce="(x) => x.id"
               :getOptionLabel="(x) => x.name_ar"
               id="possessive"
               v-model="form.possessive_form_id"
               label="صيغة التملك"
               rules="required"
             />
           </b-col>
           
           <b-col lg="4" md="6">
             <form-select
                label="موضوع بالخدمة"
                id="status-role"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.value"
                :options="[
                  {name :'نعم' , value : 1},
                  {name :'لا' , value : 0},
                ]"
                v-model="form.is_operating"
              />
           </b-col> 
           <b-col lg="4" md="6">

             <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                label="وثيقة العقار"
                accept=".pdf"
                v-model="form.estate_document"
                rules="required"
              />
           </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <save-btn
              @click="onSubmit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  <!-- </b-modal> -->
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BFormRadioGroup,
  BFormInput,
  BFormRow
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import formSelect from "@/components/form-select";
import MapSelect from "@/components/map-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import FormTextarea from "@/components/form-textarea";
import Cleave from "vue-cleave-component";
import FormMask from "@/components/form-mask";
import ClassSelect from "@/components/class-select/index.vue";
import FormFileInput from "@/components/FormFileInput.vue";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import FormModal from "@/components/FormModal.vue";
import "leaflet/dist/leaflet.css";
import { mapGetters, mapActions } from "vuex";
import { required, integer } from "@validations";

import debounce from "lodash.debounce";
import axios from "@axios";

const initForm = {};
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormTextarea,
    Cleave,
    FormMask,
    ClassSelect,
    BFormGroup,
    BFormRadioGroup,
    FormFileInput,
    BFormInput,
    BFormRow ,
    MapSelect ,
    FormModal
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    isCancel :{
      type: Boolean,
      default: () => false,
    },
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
    govsEndpoint: {
      type: String,
      default: () => "v2/map",
    },
    noAddress: {
      type: Boolean,
      default: () => false,
    },
  },
  

  data() {
    return {
      form:{},
      areasKey: 0,
      address: "",
      map: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 6,
      center: [34.8021, 37.9968],
      defaultCenter: [34.8021, 37.9968],
      marker: [],
      markerPos: {
        lng: 0,
        lat: 0,
      },
      area: null,
      gov: null,
      isTrueNgo_name : false ,
      isTrueFst_alt_ngo_name : false ,
      isTrueSec_alt_ngo_name : false ,
      hq: {},
      hqModal: false,
      mapModal: false,
      govEp: "v2/selects/governorates",
      hqFormSchema: {
        map: {
          key: "map",
        },
      },
      propertyFormOptions: [
        {
          text: "عقد إيجار",
          value: "lease",
        },
        {
          text: "حق انتفاع",
          value: "usufruct",
        },
        {
          text: "عقد عارية",
          value: "loan",
        },
        {
          text: "تخصيص إداري",
          value: "administrative_allocation",
        },
      ],
      legalFormOptions: [
        {
          text: "جمعية",
          value: "association",
        },
        {
          text: "مؤسسة",
          value: "institution",
        },
        {
          text: "اتحاد",
          value: "alliance",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("TempNgo", ["ngoInfo", "working" , "accountInfo"]),
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    areasEp() {
      return this.gov ? "v2/map/governorate-areas/" + this.gov : "v";
    },
  },
  watch: {
    // modalOpen(val) {
    //   if (val) this.init(this.intializeForm);
    // },
    area: {
      deep: true,
      handler(val) {
        if (val) this.setCenter(val);
        else this.setDefaultCenter();
      },
    },
    gov(val) {
      if (!val) this.$store.commit("areas/setOptions", []);
    },
    areasKey(val) {
      if (this.gov) this.$refs.governorateAreas.refreshOptions();
    },
  },
  
  mounted() {
    // document.getElementsByClassName("app-content")[0].classList.add("temp-ngo");
    let tem = JSON.parse(JSON.stringify(this.ngoInfo)) || {};
    let formEdit = {}
    if(Object.keys(tem).length > 0){
      formEdit.id = tem.id
      formEdit.ngo_name = tem.ngo_name
      formEdit.fst_alt_ngo_name = tem.fst_alt_ngo_name
      formEdit.sec_alt_ngo_name = tem.sec_alt_ngo_name
      formEdit.legal_form_type = tem.legal_form_type
      formEdit.objectives = tem.objectives
      formEdit.classification_ids = tem.classifications.map(el => el.id);
      formEdit.governorate_ids =  tem.governorates.map(el => el.id);
      // realEstate
      formEdit.number = tem.realEstate.number
      formEdit.estate_type_id = parseInt(tem.realEstate.estateType.id)
      formEdit.region = tem.realEstate.region
      formEdit.equity_share = tem.realEstate.equity_share
      formEdit.is_operating = tem.realEstate.is_operating
      formEdit.possessive_form_id = parseInt(tem.realEstate.possessiveForm.id)
      formEdit.estate_document = tem.realEstate.estate_document
      // hq
      formEdit.name = tem.hq.name
      formEdit.governorate_id = parseInt(tem.hq.governorate.id)
      formEdit.old_hq_governorate_id = formEdit.governorate_id
      formEdit.sub_district_id = parseInt(tem.hq.subDistrict.id)
      formEdit.address = tem.realEstate.address
      formEdit.longitude = tem.hq.longitude
      formEdit.latitude = parseInt(tem.hq.latitude)
      this.form = formEdit
      this.hq = tem.hq
    }
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      this.gov = obj.gov;
      this.area = obj.area;
      this.address = obj.address;
      this.$nextTick(() => {
        this.$refs.governorateAreas.refreshOptions(this.areasEp);
      });
    },
    setDefaultCenter() {
      this.zoom = 6;
      this.$set(this.center, 0, this.defaultCenter[0]);
      this.$set(this.center, 1, this.defaultCenter[1]);
      this.markerPos = {
        lng: 0,
        lat: 0,
      };
      this.marker = [];
    },
    async handleBlur(type , newVal) {
      let x
      //  Reset old value
      if(type == 'main'){
        this.isTrueNgo_name = false
      }
      else if(type == 'fst'){
        this.isTrueFst_alt_ngo_name = false
      }
      else if(type == 'sec'){
        this.isTrueSec_alt_ngo_name = false
      }
      // Check if value is duplicated in front
      const listOfName = [this.form.ngo_name , this.form.fst_alt_ngo_name , this.form.sec_alt_ngo_name ];  
      x = listOfName.filter(item => item === newVal).length === 1 ? false : true; 
      // Not duplicated in front => Check in back
      if(newVal !== undefined && x === false){
        let action = ''
        if(this.isCancel){
          action ='update'
        }
        else{
          action ='store'
        }
        await axios.post(`v2/establishment/check-establishment-ngo-name`, {
          name: newVal,
          slug : action
        })
        .then((res) => x= res.data.data);
      }
      // Assign values ​​according to type
      if(type == 'main'){
        this.isTrueNgo_name = x
      }
      else if(type == 'fst'){
        this.isTrueFst_alt_ngo_name = x
      }
      else if(type == 'sec'){
        this.isTrueSec_alt_ngo_name = x
      }
    },
    setCenter(area) {
      this.zoom = 13;
      this.$set(this.center, 0, area.latitude);
      this.$set(this.center, 1, area.longitude);
      this.$set(this.marker, 0, area.latitude);
      this.$set(this.marker, 1, area.longitude);
      this.markerPos = {
        lng: area.longitude,
        lat: area.latitude,
      };
    },
    updateMarker(x) {
      this.markerPos = x;
    },

    async onSubmit() {
       await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          if(this.isTrueSec_alt_ngo_name == false && this.isTrueFst_alt_ngo_name == false && this.isTrueNgo_name === false){
            this.$emit("confirm", this.form);
          }
         }
       });
    },
    
    openMapModal(form) {
      this.mapModal = true;
      if (this.hq)
        this.$nextTick(() => {
          this.$refs.mapModal.init({
            gov: this.hq.governorate.id,
            area: {
              ...this.hq.subDistrict,
              latitude: parseFloat(this.hq.latitude),
              longitude: parseFloat(this.hq.longitude),
            },
            address: this.hq.address,
          });
        });
    },
    onUpdateHqClicked() {
      if (this.hq)
        this.$refs.hqModal.init({
          longitude: this.hq.longitude,
          latitude: this.hq.latitude,
          real_estate_id: this.hq.realEstate ? this.hq.realEstate.id : null,
        });
      this.hqModal = true;
    },
    
    onLocationSelect(e) {
      this.form.governorate_id = e.govId;
      this.form.longitude = e.pos.lng;
      this.form.latitude = e.pos.lat;
      this.form.sub_district_id = e.area.id;
      this.form.address = e.address;
      this.govId = e.govId;
    },
    onHqUpdateConfirmed(form) {
      this.editHq(form);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/map-leaflet.scss";

.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
